import erc1155 from "./erc1155";
export const ercAbi = { erc1155 };
